<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <ValidationObserver ref="form">
            <div class="form-group">
              <label for="" class="form-label">Nombre *</label>
              <InputText
                v-model="name"
                rules="required"
                name="Nombre"
              ></InputText>
            </div>
            <div class="form-group">
              <label for="" class="form-label">Dirección</label>
              <input
                v-model="direction"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
            <div class="form-group">
              <label for="" class="form-label">RUC</label>
              <div class="form-row">
                <div class="col-10">
                  <InputText v-model="ruc" rules="ruc" name="RUC"></InputText>
                </div>
                <div class="col-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm btn-icon"
                    @click="fetchRucDni"
                    :disabled="loading.rucdni"
                  >
                    <i class="fa fa-fw fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group text-right">
              <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNew"
              >
                Nuevo
              </button>
              <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onSave"
              >
                Guardar
              </button>
            </div>
          </ValidationObserver>
        </div>
        <div class="col-lg-9">
          <Table
            :rows="containers.hoteles"
            :columnID="'idHotel'"
            :columns="containers.columns"
          >
            <template #rowactions="{ row }">
              <template v-if="row.origen != 0">
                <button
                  class="btn btn-xs btn-icon btn-light-warning"
                  @click="onEdit(row)"
                >
                  <span class="fa fa-fw fa-pencil-alt"></span>
                </button>
                <button
                  class="btn btn-xs btn-icon btn-light-danger ml-2"
                  @click="onDelete(row)"
                >
                  <span class="fa fa-fw fa-trash-alt"></span>
                </button>
              </template>
              <button
                @click="onShowModalHotelHoras(row)"
                class="btn btn-xs btn-icon btn-light-primary ml-1"
              >
                <span class="fa fa-fw fa-list"></span>
              </button>
            </template>
          </Table>
        </div>
      </div>
    </div>
    <ModalHotelHoras
      v-if="containers.showModalHotelHoras"
      :hotel="containers.hotel"
      :show="containers.showModalHotelHoras"
      @close="containers.showModalHotelHoras = false"
    />
  </div>
</template>
<script>
import Table from "../../../modules/shared/components/Table.vue";
import InputText from "../../../modules/shared/components/InputText.vue";
import ModalHotelHoras from "@/modals/HotelHoras.vue";
export default {
  layout: "app",
  components: {
    ModalHotelHoras,
    InputText,
    Table
  },
  data() {
    return {
      name: "",
      direction: "",
      credito: false,
      ruc: "",
      loading: {
        view: true,
        crud: false,
        rucdni: false,
      },
      containers: {
        id: null,
        hoteles: [],
        hotel: null,
        showModalHotelHoras: false,
        columns: [
          {
            key: "actions",
            label: "",
            width: 80
          },
          {
            key: "nombre",
            label: "Nombre",
            width: 200
          },
          {
            key: "ruc",
            label: "RUC",
            width: 150
          },
          {
            key: "direccion",
            label: "Dirección",
            width: 150
          },
          {
            key: "usuarioCreador",
            label: "UC",
            head_class: "text-center",
            width: 80
          },
          {
            key: "usuarioModif",
            label: "UM",
            head_class: "text-center",
            width: 80
          }
        ]
      }
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content }
    } = await vm.axios.get("/mantenimiento/hoteles");

    vm.containers.hoteles = content.hoteles;

    vm.loading.view = false;
  },
  methods: {
    async onSave() {
      let vm = this;

      const validated = await vm.$refs.form.validate();

      if (!validated) {
        vm.$toast.fire({
          icon: "warning",
          title: "Revise y verifique los campos en rojo"
        });

        return;
      }

      let fd = {
        name: String(vm.name || "").trim(),
        direction: String(vm.direction || "").trim(),
        credito: vm.credito ? 1 : 0,
        ruc: vm.ruc || "",
        _method: "POST"
      };

      vm.loading.crud = true;

      let endpoint = "/mantenimiento/hoteles";

      if (vm.containers.id) {
        endpoint = `/mantenimiento/hoteles/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then(response => {
          if (vm.containers.id) {
            let findRow = vm.containers.hoteles.find(
              item => item.idHotel == vm.containers.id
            );

            findRow.nombre = fd.name;
            findRow.direccion = fd.direction || "";
            findRow.usuarioModif = vm.$store.state.user.codigo;
            findRow.ruc = fd.ruc || "";
          } else {
            vm.containers.hoteles.push({
              nombre: fd.name,
              direccion: fd.direction || "",
              idHotel: response.data.content.id,
              usuarioCreador: vm.$store.state.user.codigo,
              ruc: fd.ruc || ""
            });

            vm.containers.id = response.data.content.id;
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch(error => {
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    onEdit(pItem) {
      let vm = this;
      vm.containers.id = pItem.idHotel;
      vm.name = pItem.nombre;
      vm.direction = pItem.direccion == "null" ? "" : pItem.direccion || "";
      vm.ruc = pItem?.ruc || "";

      window.scrollTo(0, 0);
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
        "",
        "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/hoteles/${pItem.idHotel}`)
          .then(response => {
            let tempRegistros = [...vm.containers.hoteles];
            vm.containers.hoteles = tempRegistros.filter(
              item => item.idHotel != pItem.idHotel
            );
          })
          .catch(error => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNew() {
      let vm = this;
      vm.containers.id = null;
      vm.ruc = "";
      vm.name = "";
      vm.direction = "";
    },
    onShowModalHotelHoras(pItem) {
      this.containers.hotel = pItem;
      this.containers.showModalHotelHoras = true;
    },

    async fetchRucDni() {
      const vm = this;

      const type = "ruc";
      const number = String(vm.ruc).trim();

      if (!number) {
        vm.$toast.fire({
          icon: "warning",
          title:
            "Ingrese un Número de documento"
        });
        return;
      }

      vm.name = "";
      vm.direction = "";
      vm.loading.rucdni = true;

      try {
        const response = await vm.axios.get("/consulta/rucdni", {
          params: {
            type,
            number
          }
        });

        const { nombre, direccion } = response.data;

        vm.name = nombre;
        vm.direction = direccion;
      } catch (error) {
        console.error({ error: error?.response || error });

        vm.$toast.fire({
          icon: "error",
          title: "Error al consultar los datos del documento"
        });
      } finally {
        vm.loading.rucdni = false;
      }
    }
  }
};
</script>
